import { atom } from 'recoil';
import { ModelListQueryrunResponse } from '../../api/__gen__/data-contracts';

export const AQueryHistoryState = atom<ModelListQueryrunResponse>({
  key: 'AQueryHistoryState',
  default: { items: [] },
});
